import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, categoryMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryMap[slug] : undefined;
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-16">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-semibold text-foreground-950 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: category.name }]} />

          <div className="py-8 md:py-12">
            <div className="flex items-center gap-4 mb-3">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-primary-100/70 rounded-lg flex items-center justify-center">
                <i className={`${category.icon} text-2xl text-primary-500`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-semibold text-foreground-950">{category.name}</h1>
                <p className="text-sm text-foreground-500 mt-1">{categoryArticles.length} 篇文章</p>
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              {category.description}
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 pb-14 md:pb-20">
            <aside className="lg:w-56 flex-shrink-0">
              <div className="sticky top-20">
                <h3 className="text-sm font-semibold text-foreground-950 mb-3">研究分类</h3>
                <nav className="space-y-1">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
                        cat.slug === slug
                          ? 'bg-primary-100/70 text-primary-500 font-medium'
                          : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                      }`}
                    >
                      <i className={`${cat.icon} text-base`}></i>
                      <span>{cat.name}</span>
                      <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                    </Link>
                  ))}
                </nav>
              </div>
            </aside>

            <div className="flex-1 min-w-0">
              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {categoryArticles.map((article) => (
                    <ArticleCard key={article.slug} article={article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <p className="text-foreground-500">该分类下暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}